"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallGetStarted = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const invitation_details_1 = require("../../context/invitation_details");
const company_settings_1 = require("../../context/company_settings");
const intro_1 = require("./intro");
const wide_button_1 = require("./wide_button");
const powered_by_streem_footer_1 = require("../lobby/powered_by_streem_footer");
const analytics_1 = require("@streem/analytics");
const ExpirationText = ({ expiresIn }) => {
    const text = expiresIn ? `Invitation expires in ${expiresIn}` : '';
    return ((0, jsx_runtime_1.jsx)(ExpirationTextContainer, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "p", color: "medium" }, { children: text })) }));
};
const CallGetStarted = props => {
    const { agentName, agentBio, agentAvatar, companyName, expiresIn } = (0, invitation_details_1.useInvitationDetails)();
    const { logoUrl } = (0, company_settings_1.useCompanySettings)();
    const pluralizeExpiresIn = (timeRemaining) => {
        if (timeRemaining < 1) {
            return 'less than a minute';
        }
        else {
            const roundedDuration = Math.ceil(timeRemaining);
            return timeRemaining === 1 ? `${roundedDuration} minute` : `${roundedDuration} minutes`;
        }
    };
    const [humanizedExpiresIn, setHumanizedExpiresIn] = (0, react_1.useState)(pluralizeExpiresIn(expiresIn()));
    (0, react_1.useEffect)(() => {
        const expirationChecker = setInterval(() => {
            const updatedExpiresIn = pluralizeExpiresIn(expiresIn());
            if (updatedExpiresIn !== humanizedExpiresIn) {
                setHumanizedExpiresIn(updatedExpiresIn);
            }
        }, 10000);
        return () => clearInterval(expirationChecker);
    }, [expiresIn, humanizedExpiresIn]);
    (0, react_1.useEffect)(() => {
        (0, analytics_1.recordScreenViewed)('call: get started');
    }, []);
    return ((0, jsx_runtime_1.jsxs)(TopColumn, { children: [(0, jsx_runtime_1.jsx)(intro_1.Intro, { avatarSrc: agentAvatar, displayName: agentName, bio: agentBio, company: companyName, logo: logoUrl, size: "large" }), (0, jsx_runtime_1.jsx)(GetStartedButton, { onClick: props.onStart }), (0, jsx_runtime_1.jsx)(ExpirationText, { expiresIn: humanizedExpiresIn }), !props.hideStreemBranding && (0, jsx_runtime_1.jsx)(powered_by_streem_footer_1.PoweredByStreemFooter, {})] }));
};
exports.CallGetStarted = CallGetStarted;
const GetStartedButton = ({ onClick }) => {
    return ((0, jsx_runtime_1.jsx)(wide_button_1.WideButton, Object.assign({ testid: "get-started-btn", "data-streem-analytics": "call-get-started-button", onClick: onClick }, { children: "Get Started" })));
};
const TopColumn = (0, ui_react_1.styled)(ui_react_1.Column)({
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100vw',
    marginTop: '10vh',
});
const ExpirationTextContainer = ui_react_1.styled.div(({ theme }) => ({
    color: theme.colors.grey30,
    marginTop: theme.space[3],
}));
//# sourceMappingURL=call_get_started.js.map